import { Component, EventEmitter, Input, Output } from '@angular/core';

interface MatchStatsSelection {
  title: string;
  users: any[];
}

@Component({
  selector: 'app-match-stats',
  templateUrl: './match-stats.component.html',
  styleUrls: ['./match-stats.component.scss'],
  standalone: false,
})
export class MatchStatsComponent {
  @Input() match: any;
  @Input() variant: 'default' | 'live' = 'default';
  @Input() expanded = true;
  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() usersSelected = new EventEmitter<MatchStatsSelection>();

  get isLive(): boolean {
    return this.variant === 'live';
  }

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }

  open(title: string, users: any[]): void {
    this.usersSelected.emit({ title, users: users ?? [] });
  }

  get scoreResults(): any[] {
    return this.match?.stats?.scoreResults ?? [];
  }
}
